<script setup lang="ts">
import { computed } from 'vue';
import { type CaregiverCostGroup } from '@/api/patient-monthly-metrics';
import { formatCurrency } from '@/utils/currency';
import { mergeCostGroups } from '@/utils/cost-groups';

const props = defineProps<{
  groups: CaregiverCostGroup[];
}>();

const rows = computed(() => mergeCostGroups(props.groups));
</script>

<template>
  <v-card
    elevation="2"
    class="overflow-x-auto my-1"
  >
    <v-table density="compact">
      <thead>
        <tr>
          <th>Costo Bruto por turno</th>
          <th class="text-center">
            Cantidad de Turnos
          </th>
          <th>Costo Bruto Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.cost"
        >
          <td>{{ formatCurrency(row.cost) }}</td>
          <td class="text-center font-weight-bold">
            {{ row.totalShifts }}
          </td>
          <td class="font-weight-bold">
            {{ formatCurrency(row.totalCost) }}
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card>
</template>
